import {Component, OnDestroy, OnInit} from '@angular/core';
import {GridCellComponent} from '@shared/components/cell-components/grid-cell/grid-cell.component';
import {CellEditorComponentBase} from '@shared/components/cell-components/cell-component';

@Component({
    standalone: false,
    selector: 'app-entity-cell-viewer',
  templateUrl: './entity-cell-viewer.component.html',
  styleUrls: ['./entity-cell-viewer.component.scss']
})
export class EntityCellViewerComponent extends CellEditorComponentBase implements OnInit, OnDestroy {

  entityNames: string[];
  constructor() {
    super();
    this.entityNames = [];
  }

  ngOnInit(): void {
    const commaSepratedEntityNames = this.item.cells['EntityNames']?.value;
    this.entityNames = commaSepratedEntityNames.split(',');
  }
  ngOnDestroy() {
  }
}
